/* src/app/components/controls/sem-text-box/sem-text-box.component.css */
.hidden-value-input-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}
.hidden-value-input-wrapper .hidden-icon {
  display: none;
}
.hidden-input-with-icon {
  padding-right: 35px !important;
}
.reveal-icon-btn-inside {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #666;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.reveal-icon-btn-inside:hover {
  color: #333;
}
.reveal-icon-btn-inside mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.copy-icon-input-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}
.copy-icon-input-wrapper.has-copy-icon {
  z-index: 100;
}
.copy-icon-input-wrapper.has-copy-icon input.sem-text-box {
  padding-right: 30px !important;
}
.copy-icon-btn-inside {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #666;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
}
.copy-icon-btn-inside:hover {
  color: #333;
}
.copy-icon-btn-inside mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
/*# sourceMappingURL=sem-text-box.component.css.map */
